import { styled } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';
import { animated } from 'react-spring';

export const TabWrapper = styled.div`
  min-height: 44px;
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 4px;
  position: relative;
  z-index: 1;
  width: 100%;
`;

export const Indicator = styled(animated.span)`
  position: absolute;
  bottom: 0;
  height: calc(100% - 8px);
  transition: ${animationTransition('background-color')};
  left: 0;
  width: 0;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  z-index: 0;
  top: 50%;
`;

export const TabsRoot = styled.div<Readonly<{ width?: string; isMobile?: boolean }>>`
  width: ${({ width, isMobile }) => (width && !isMobile ? width : isMobile ? '100%' : 'initial')};
  position: relative;
  background: ${({ theme }) => theme.colors.mono2};
  border-radius: 12px;
`;
